import type { ApiClient } from '../../../shared/api/api-client';

export type OrganizationMeFlat = Record<string, unknown>;

export async function getOrganizationMe(client: ApiClient): Promise<OrganizationMeFlat> {
  return client.request<OrganizationMeFlat>('/organizations/me', { method: 'GET' });
}

export async function patchOrganizationMe(
  client: ApiClient,
  body: Record<string, unknown>
): Promise<OrganizationMeFlat> {
  return client.request<OrganizationMeFlat>('/organizations/me', { method: 'PATCH', body });
}

export async function patchOrganizationMeSettings(
  client: ApiClient,
  body: Record<string, unknown>
): Promise<{ settings: Record<string, unknown> }> {
  return client.request<{ settings: Record<string, unknown> }>('/organizations/me/settings', { method: 'PATCH', body });
}

/** PATCH /api/v1/organizations/me/user-agreement — текст пользовательского соглашения организации. */
export async function patchOrganizationMeUserAgreement(
  client: ApiClient,
  body: { user_agreement_text?: string }
): Promise<Record<string, unknown>> {
  return client.request<Record<string, unknown>>('/organizations/me/user-agreement', { method: 'PATCH', body });
}

export type OrgModuleItem = {
  module_code: string;
  name: string;
  enabled: boolean;
  state_source: string;
  in_plan: boolean;
  is_core: boolean;
  embed_brand_single_org: boolean;
};

export async function getOrganizationMeModules(
  client: ApiClient
): Promise<{ items: OrgModuleItem[] }> {
  return client.request<{ items: OrgModuleItem[] }>('/organizations/me/modules', { method: 'GET' });
}

export async function patchOrganizationMeModules(
  client: ApiClient,
  modules: { module_code: string; enabled: boolean }[]
): Promise<void> {
  await client.request<void>('/organizations/me/modules', {
    method: 'PATCH',
    body: { modules },
  });
}

export type SmtpProbeResponse = { ok: boolean; message: string };
export type SmtpTestEmailResponse = { ok: boolean; message: string; to: string };

export async function postOrgMeSmtpProbe(client: ApiClient): Promise<SmtpProbeResponse> {
  return client.request<SmtpProbeResponse>('/organizations/me/smtp-probe', { method: 'POST' });
}

export async function postOrgMeSmtpTestEmail(
  client: ApiClient,
  to: string
): Promise<SmtpTestEmailResponse> {
  return client.request<SmtpTestEmailResponse>('/organizations/me/smtp-test-email', {
    method: 'POST',
    body: { to },
  });
}
